export default "__VITE_ASSET__64f4cb31__"